<!--
 任务反馈组件
 @author 赵换玲
 @date 2019/12/26
 -->
<template>
    <div class="lnk-feedback">
        <el-dialog v-loading="missionDialogLoading"
                   :element-loading-text="$t('LnkFeedback.hintLoading')"
                   element-loading-spinner="el-icon-loading"
                   element-loading-background="rgba(0, 0, 0, 0)"
                   class="mission-feedback-dialog"
                   :title="$t('LnkFeedback.title')"
                   :class="themeClass"
                   :visible.sync="editorFormVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   append-to-body
                   @close="closeMissionDialog"
                   :lock-scroll="false">
            <el-form :model="formData" :rules="rules" ref="mainForm" :inline="true" label-width="100px"
                     size="mini">
                <el-form-item :label="$t('LnkFeedback.fieldPFirstName')" prop="pFirstName" style="width: 45%;">
                    <el-input class="text-content" :placeholder="$t('LnkFeedback.placeholderAbstracts')"
                              v-model="formData.pFirstName">
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('LnkFeedback.fieldRFirstName')" style="width: 45%;">
                    <el-input class="text-content" :placeholder="$t('LnkFeedback.placeholderAbstracts')"
                              v-model="formData.rFirstName">
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('LnkFeedback.fieldAbstracts')" prop="abstracts" style="width: 92%;">
                    <el-input type="textarea" class="text-content" :autosize="{ minRows: 3, maxRows: 6}"
                              :placeholder="$t('LnkFeedback.placeholderAbstracts')"
                              v-model="formData.abstracts">
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('LnkFeedback.fieldSelectdate')" prop="selectdate" style="display: block">
                    <el-date-picker v-model="formData.selectdate" value-format="yyyy-MM-dd" type="daterange"
                                    range-separator="-"
                                    :start-placeholder="$t('LnkFeedback.placeholderBeginDate')"
                                    :end-placeholder="$t('LnkFeedback.placeholderEndDate')"/>
                </el-form-item>
                <el-form-item style="margin-left: 100px;width: calc(100% - 120px);">
                    <el-radio-group v-model="formData.uploadType" @change="changeUploadType">
                        <el-radio :label="'Screen Cut'">{{$t('LnkFeedback.labelScreenCut')}}</el-radio>
                        <el-radio :label="'Picture'">{{$t('LnkFeedback.fieldPicture')}}</el-radio>
                        <el-radio :label="'None'">{{$t('LnkFeedback.fieldNone')}}</el-radio>
                        <el-radio :label="'pastePicture'">{{$t('LnkFeedback.fieldPaste')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-show="formData.uploadType === 'Screen Cut'"
                              style="position: relative;margin-left: 57px;">
                    <el-button
                            style="position:absolute;display: inline-block;padding:10px 10px;color: white;background-color: grey;border: none;opacity: 0.8;border-radius: 5px"
                            @click="showMissionCanvas">
                        <i class="el-icon-edit" style="font-size: 17px"></i>
                    </el-button>
                    <img ref="missionFeedbackImg" :src="missionImg" style="margin-left: 48px;width: calc(100% - 35px)">
                    <img v-show="false" id="missionFeedbackImgTmp" :src="missionImgTmp" width="82%"
                         style="margin-left: 48px">
                </el-form-item>
                <el-form-item class="paste-form-item" v-show="formData.uploadType === 'Picture'" prop="imgUrl">
                    <el-upload
                            ref="upload"
                            :name="attachmentName"
                            :data="uploadData"
                            :auto-upload="false"
                            :http-request="uploadImgWithoutToken"
                            :on-error="errorUpload"
                            list-type="picture-card"
                            :file-list="fileList">
                        <i class="el-icon-plus"></i>
                        <!-- 插槽插入按钮到遮罩上, 默认带有删除按钮, 若设置组件属性disabled或者delete-icon=false则不显示 -->
                        <template slot="mask-btn">
                            <span @click.stop="showDialog=!showDialog">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                        </template>
                    </el-upload>
                    <el-dialog append-to-body :visible.sync="showDialog">
                        <img width="100%" :src="imageUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <el-form-item class="paste-form-item" v-show="formData.uploadType === 'pastePicture'">
                    <!--粘贴图片-->
                    <div class="paste-img-line">
                        <div class="paste-img-column" v-for="(img,index) in attachList" :key="index">
                            <img class="paste-pic-img"
                                 :src="img.attachmentPath"
                                 @click="sliderImg(img, index)">
                            <div class="delete-mask" @click="deleteImg(img,index)">
                                <i class="el-icon-delete" style="margin: 0 auto;cursor: pointer"></i>
                            </div>
                        </div>
                        <div id="paste-pic-box" ref="pastePicBox" contenteditable="true"></div>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-row>
                    <el-col :span="24" align="center">
                        <el-button size="mini" @click="closeMissionDialog()">{{$t('global.cancel')}}</el-button>
                        <el-button type="primary" size="mini"
                                   @click="validateFormData()">{{$t('global.confirm')}}</el-button>
                    </el-col>
                </el-row>
            </span>
        </el-dialog>
        <div v-show="missionCanvasFlag" class="mission-canvas-modal"></div><!--遮罩-->
        <div v-show="missionCanvasFlag" id="mission-canvas" ref="missionCanvas"
             style="position: absolute;left: calc(50% - 600px);top: 5%;z-index: 10000;">
            <canvas id="missionFeedbackEdit" ref="missionFeedbackEdit" height="650" width="1200"></canvas>
            <canvas id="missionFeedbackEditShadow" ref="missionFeedbackEditShadow" height="650" width="1200"
                    v-show="missionShadow" style="position:absolute;top:0;z-index:20000"></canvas>
            <span ref="charWidthCalculator" style="position: absolute"></span>
            <div class="mission-canvas-button-group" style="position:absolute;right: calc(50% - 600px)">
                <span class="iconfont icon-yuandian" :class="{'icon-line-width-active':lineWidth == '2'}"
                      @click="changeLineWidth('2')"></span>
                <span class="iconfont icon-yuandianxiao" :class="{'icon-line-width-active':lineWidth == '5'}"
                      @click="changeLineWidth('5')"></span>
                <span class="iconfont icon-yuandianzhong" :class="{'icon-line-width-active':lineWidth == '10'}"
                      @click="changeLineWidth('10')"></span>
                <span class="iconfont icon-shixinzhengfangxing icon-shixinzhengfangxing-red"
                      :class="{'icon-stroke-style-active':strokeStyle == '#cc0000'}"
                      @click="changeStrokeStyle('#cc0000')"></span>
                <span class="iconfont icon-shixinzhengfangxing icon-shixinzhengfangxing-blue"
                      :class="{'icon-stroke-style-active':strokeStyle == '#3333ff'}"
                      @click="changeStrokeStyle('#3333ff')"></span>
                <span class="iconfont icon-shixinzhengfangxing icon-shixinzhengfangxing-black"
                      :class="{'icon-stroke-style-active':strokeStyle == '#000000'}"
                      @click="changeStrokeStyle('#000000')"></span>
                <span class="iconfont icon-ai37" :style="{color:(selectedDraw === 'Arrow'?'#00cc66':'white')}"
                      @click="drawArrow"></span>
                <span class="iconfont icon-juxing" :style="{color:(selectedDraw === 'Rectangle'?'#00cc66':'white')}"
                      @click="drawRectangle"></span>
                <span class="iconfont icon-yuanxingweixuanzhong"
                      :style="{color:(selectedDraw === 'Circle'?'#00cc66':'white')}" @click="drawCircle"></span>
                <span class="iconfont icon-bianji" :style="{color:(selectedDraw === 'Line'?'#00cc66':'white')}"
                      @click="drawLine"></span>
                <span class="iconfont icon-xingzhuang-wenzi"
                      :style="{color:(selectedDraw === 'Char'?'#00cc66':'white')}" @click="drawChar"></span>
                <span class="iconfont icon-fanhui" @click="lastStep"></span>
                <span class="iconfont icon-close" @click="closeMissionCanvas"
                      style="font-size: 22px;color: #ff0000"></span>
                <span class="iconfont icon-checked" @click="saveMissionCanvas"
                      style="font-size: 22px;color: #00cc66"></span>
            </div>
        </div>
    </div>
</template>

<script>
    import html2canvas from 'html2canvas';
    import themeClass from '../../mixins/theme-class';

    export default {
        name: 'lnk-feedback',
        mixins: [themeClass],
        data() {
            return {
                editorFormVisible: false,               // 问题反馈弹窗是否可见
                firstCreat: true,                       // 是否为第一次创建
                formData: {},                           //问题反馈表单对象
                oldData: {},                            // 前次创建的表单数据
                rules: {
                    abstracts: [{required: true, message: ' ', trigger: ['blur', 'change']}],
                    selectdate: [{required: true, message: ' ', trigger: ['blur', 'change']}],
                    pFirstName: [{required: true, message: ' ', trigger: ['blur', 'change']}]
                },
                fileList: [],                           //上传图片list
                uploadURL: this.FeedBackAttachmentUrl,
                uploadData: {                           // 上传文件时需要携带的数据, 不同接口不同需求, 这是标准附件接口要求
                    headId: '',
                    moduleType: 'upload-mission-feedback'
                },
                attachmentName: 'uploadAttachment',     // 上传文件时的文件的字段名，标准接口是uploadAttachment
                showDialog: false,                      //图片删除
                imageUrl: '',                           //图片路径
                lineWidth: '5',                         //用于绑定选中样式
                strokeStyle: '#cc0000',                 //用于绑定选中样式
                missionCanvasFlag: false,                //截图编辑画布是否显示
                missionImg: '',                          //截图base64编码
                missionImgTmp: '',                       //用于渲染返回上一步的画框
                ctx: {},                                 //画布对象
                ctxShadow: {},                           //用于绘制的画布阴影对象，每次绘制，将绘制结果转移到画布对象，绘制图片base64位码推进missionImgList，然后清空。
                missionImgList: [],                      //截图编辑图片栈，存储每一步的图形
                missionShadow: true,                     //是否需要阴影画布，目前只有画线不需要
                submitting: false,                       //控制传图片钩子函数的不可重复触发
                selectedDraw: '',                        //当前所选绘制方式
                charX: 0,                               //文字输入框横坐标
                charY: 0,                               //文字输入框纵坐标
                charFlag: false,                        //输入框是否创建flag
                missionDialogLoading: false,
                attachList: [],                         // 上传附件
                FeedBackProjectId: '',                  // 反馈项目Id
                FeedBackAttachmentUrl: '',              // 附件上传地址
                FeedBackPrestoreIdUrl: '',              // 预存id地址
                LinkFeedBackUrl: '',                     // 提交反馈地址
                FeedBackImgUrl: ''                       // 上传屏幕截图地址
            };
        },
        methods: {
            /**
             * 自定义图片上传方法，覆盖element默认上传，去除token认证信息
             * @author 赵换玲
             * @date 2019-12-25 11:29
             * @param 上传信息
             **/
            uploadImgWithoutToken(data) {
                this.$file.upload({
                    action: this.FeedBackAttachmentUrl,
                    withToken: false,
                    file: data.file,
                    data: this.uploadData,
                    onSuccess: (data) => { // 成功回调
                        this.successUpload()
                    },
                    onError: () => {
                        this.errorUpload()
                    },
                })
            },
            /**
             * 删除图片
             * @author 赵换玲
             * @date 2019-12-23 10:17
             * @param row 图片
             * @param index 图片下标
             **/
            async deleteImg(row, index) {
                await this.$file.deleteByIds([row.id]);
                this.attachList.splice(index, 1)
            },
            /**
             *图片预览
             * @author 赵换玲
             * @date 2019-12-23 18:31
             * @param row 图片
             * @param index 图片下标
             **/
            sliderImg(row, index) {
                this.$slider.pick({
                    picData: this.attachList,
                    picKey: 'attachmentPath',
                    pageIndex: index,
                    picInfo: '',
                    showTitle: false,
                })
            },
            /**
             *上传类型为粘贴图片时，绑定paste事件
             * @author 赵换玲
             * @date 2019-12-23 18:31
             * @param val 上传类型
             **/
            changeUploadType(val) {
                if (val === 'pastePicture') {
                    this.$refs.pastePicBox.addEventListener('paste', this.onPaste)
                }
            },
            /**
             * 图片粘贴触发事件，上传图片
             * @author 赵换玲
             * @date 2019-12-20 18:56
             * @param e
             **/
            onPaste(e) {
                if (e.clipboardData && e.clipboardData.items) {
                    let items = e.clipboardData.items;
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].type.indexOf('image') !== -1) {
                            let file = items[i].getAsFile();
                            e.preventDefault();
                            /*上传文件*/
                            this.$file.upload({
                                action: this.FeedBackAttachmentUrl,
                                withToken: false,
                                file,
                                data: this.uploadData,
                                onSuccess: (data) => { // 成功回调
                                    this.img = data.newRow.attachmentPath;
                                    this.attachList.push(data.newRow)
                                },
                                onError: () => {
                                    this.$nav.error('上传失败！')
                                },
                            })
                        }
                    }
                }
            },
            /**
             * 获取企业参数
             * @author 赵换玲
             * @date 2019-12-23 11:09
             **/
            async getCfgProperty() {
                try {
                    const {result, rows, success} = await this.$http.post(`${LinkVue.prefixUrl}/cfgProperty/queryByExamplePage`, {
                        filtersRaw: [{
                            id: 'key',
                            property: 'key',
                            operator: 'IN',
                            value: '[FeedBackURL, FeedBackProjId]'
                        }],
                        oauth: 'ALL'
                    });

                    if (success) {
                        let feedbackUrl, feedbackProjId;
                        rows.forEach((item) => {
                            if (item.key === 'FeedBackProjId') {
                                feedbackProjId = item.value
                            } else if (item.key === 'FeedBackURL') {
                                feedbackUrl = item.value
                            }
                        })
                        if (!feedbackUrl) {
                            this.$nav.error('反馈地址不存在，请检查系统参数配置！')
                            return
                        }
                        if (!feedbackProjId) {
                            this.$nav.error('反馈项目di不存在，请检查系统参数配置！')
                            return
                        }

                        /*当前项目在体验环境中，项目信息维护中的项目id*/
                        this.FeedBackProjectId = feedbackProjId
                        /*附件上传地址*/
                        this.FeedBackAttachmentUrl = this.$lv.$utils.pathJoin(feedbackUrl, 'action/link/attachment/insertAttachment')
                        this.uploadURL = this.FeedBackAttachmentUrl;
                        /*生成id地址*/
                        this.FeedBackPrestoreIdUrl = this.$lv.$utils.pathJoin(feedbackUrl, 'action/link/ServiceProject/preDefaultValue');
                        /*反馈地址*/
                        this.LinkFeedBackUrl = this.$lv.$utils.pathJoin(feedbackUrl, 'action/link/ServiceProject/openInsertFeedback');
                        /*图片base64上传地址*/
                        this.FeedBackImgUrl = this.$lv.$utils.pathJoin(feedbackUrl, 'action/link/image/insertOuterImage');
                    } else {
                        this.$nav.error('初始化反馈配置信息失败！' + result)
                    }
                } catch (e) {
                    this.$nav.error('初始化反馈配置信息失败！' + e)
                }
            },
            /**
             * 打开mission反馈弹窗，初始化对象，获取屏幕截图
             * @author 江涛
             * @date 2019/2/20
             */
            async openMissionDialog() {
                await this.$lv.$utils.delay(150);
                this.missionDialogLoading = true;
                setTimeout(() => {
                    this.editorFormVisible = true;
                }, 100);
                setTimeout(() => {
                    this.takeScreenshot();  // 当前屏幕截图
                }, 0);
                this.ctx = this.$refs.missionFeedbackEdit.getContext('2d');
                this.ctxShadow = this.$refs.missionFeedbackEditShadow.getContext('2d');
                this.ctx.lineWidth = '5';
                this.ctxShadow.lineWidth = '5';
                this.ctx.strokeStyle = '#cc0000';
                this.ctxShadow.strokeStyle = '#cc0000';
                this.fileList = [];//清空上传文件
                this.submitting = false;
                //预存反馈id
                const res = await this.$http.axios({
                    method: 'post',
                    url: this.FeedBackPrestoreIdUrl
                });
                if (res.data.success) {
                    const data = {id: res.data.result.id};
                    data.pFirstName = appCtx.firstName; // 提出人姓名
                    data.rFirstName = appCtx.firstName; // 责任人姓名
                    data.uploadType = 'Screen Cut';//上传图片类型
                    data.projectId = this.FeedBackProjectId || ''; //项目id
                    this.formData = data;
                    this.uploadData.headId = data.id;
                    this.uploadData.comments = JSON.stringify({
                        username: appCtx.username,
                        createdName: appCtx.firstName
                    });
                } else {
                    this.$nav.error(res.data.result);
                    this.editorFormVisible = false;
                }
                if (!this.firstCreat) {
                    this.formData.projectId = this.oldData.projectId;
                    this.formData.pFirstName = this.oldData.pFirstName;
                    this.formData.rFirstName = this.oldData.rFirstName;
                    this.formData.selectdate = this.oldData.selectdate;
                }
                this.$nextTick(() => {
                    if (this.$refs.mainForm) {
                        this.$refs.mainForm.clearValidate()
                    }
                });
            },
            /**
             *  关闭对话框
             *  @author      江涛
             *  @date        2019-03-19
             */
            closeMissionDialog() {
                this.editorFormVisible = false;
                this.fileList = [];
                this.missionImg = '';
                this.attachList = []
            },
            /**
             * 获取屏幕截图,转换成base64编码
             * @author 江涛
             * @date 2019/2/20
             */
            takeScreenshot() {
                html2canvas(document.body, {logging: false}).then((canvas) => {
                    this.missionImg = canvas.toDataURL('image/jpeg', 1.0);
                    this.missionDialogLoading = false;
                }).catch(err => {
                    console.log('截取屏幕快照失败！')
                    console.error(err)
                });
            },
            /**
             * mission反馈弹窗提交
             * @author 江涛
             * @date 2019/2/20
             */
            validateFormData() {
                const that = this;
                const formref = that.$refs.mainForm;
                formref.validate(async (valid) => {
                    if (!valid) {
                        that.$nav.error(this.$t('LnkFeedback.hintForm'));
                    } else {
                        formref.clearValidate();

                        this.formData.startdt = this.formData.selectdate[0];
                        this.formData.enddt = this.formData.selectdate[1];
                        if (that.formData.uploadType == 'Screen Cut') {
                            try {
                                var response = await that.$http.axios({
                                    method: 'post',
                                    url: this.FeedBackImgUrl,
                                    data: {
                                        url: that.missionImg,
                                        parentid: this.formData.id,
                                        module: 'upload-mission-feedback'
                                    }
                                });
                                if (response.data.success) {
                                    that.successUpload();
                                } else {
                                    that.errorUpload();
                                }
                            } catch (e) {
                                that.errorUpload();
                            }
                        } else if (that.formData.uploadType == 'Picture') {
                            that.$refs.upload.submit();
                        } else {
                            that.successUpload();
                        }
                    }
                });
            },
            /**
             * 图片保存成功后调用
             * @author 江涛
             * @date 2019/3/8
             */
            async successUpload() {
                const that = this;
                if (!this.submitting) {
                    this.submitting = true;
                    const res = await this.$http.axios({
                        method: 'post',
                        url: this.LinkFeedBackUrl,
                        data: this.formData
                    });
                    if (res.data.success) {
                        that.$message.success('保存反馈成功');
                        that.editorFormVisible = false;
                        that.firstCreat = false;
                        that.oldData = linkTools.deepCopy(that.formData);
                        that.missionImg = '';
                        this.attachList = []
                    } else {
                        that.$message.error('保存数据时发生错误' + res.data.result)
                    }
                }
            },
            /**
             * 图片保存失败后调用
             * @author 江涛
             * @date 2019/3/8
             */
            errorUpload() {
                this.$nav.error(this.$t('LnkFeedback.hintUploadErr'));
            },
            /**
             * 显示截图编辑画布,将截图渲染到画布上
             * @author 江涛
             * @date 2019/2/22
             */
            showMissionCanvas() {
                this.ctx.drawImage(this.$refs.missionFeedbackImg, 0, 0, 1200, 650);
                this.editorFormVisible = false;
                this.missionCanvasFlag = true;
            },
            /**
             * 放弃截图编辑画布
             * @author 江涛
             * @date 2019/2/22
             */
            closeMissionCanvas() {
                this.judgeChar();
                this.editorFormVisible = true;
                this.missionCanvasFlag = false;
                this.missionImgList = [];//清空缓存
            },
            /**
             * 保存截图编辑画布
             * @author 江涛
             * @date 2019/2/22
             */
            saveMissionCanvas() {
                this.judgeChar();
                this.missionImg = this.$refs.missionFeedbackEdit.toDataURL('image/jpeg', 1.0);
                this.editorFormVisible = true;
                this.missionCanvasFlag = false;
                this.missionImgList = [];//清空缓存
            },
            /**
             * 选择线宽
             * @author 江涛
             * @date 2019/2/25
             */
            changeLineWidth(x) {
                this.ctx.lineWidth = x;
                this.ctxShadow.lineWidth = x;
                this.lineWidth = x;
            },
            /**
             * 选择颜色
             * @author 江涛
             * @date 2019/2/25
             */
            changeStrokeStyle(x) {
                this.ctx.strokeStyle = x;
                this.ctxShadow.strokeStyle = x;
                this.strokeStyle = x;
            },
            /**
             * 画矩形
             * @author 江涛
             * @date 2019/2/22
             */
            drawRectangle() {
                this.judgeChar();
                let x = 0,
                    y = 0,
                    flag = false,
                    that = this;
                this.selectedDraw = 'Rectangle';
                this.missionCanvasShadow(true, function () {
                    //是否需要阴影画布
                    that.$refs.missionFeedbackEditShadow.onmousedown = function (e) {
                        flag = true;
                        x = e.offsetX; // 鼠标落下时的X
                        y = e.offsetY; // 鼠标落下时的Y
                    };
                    that.$refs.missionFeedbackEditShadow.onmouseup = function (e) {
                        flag = false;
                        that.ctxShadow.clearRect(0, 0, that.$refs.missionFeedbackEditShadow.width, that.$refs.missionFeedbackEditShadow.height);//清空影子
                        that.ctx.strokeRect(x, y, e.offsetX - x, e.offsetY - y);//画在主体上
                        that.ctx.save();//保存主体
                        that.missionImgList.push(document.getElementById('missionFeedbackEdit').toDataURL());               // 每次 mouseup 都保存一次画布状态
                    };
                    that.$refs.missionFeedbackEditShadow.onmousemove = function (e) { // 绘制方法
                        if (flag) {
                            that.ctxShadow.clearRect(0, 0, that.$refs.missionFeedbackEditShadow.width, that.$refs.missionFeedbackEditShadow.height);
                            that.ctxShadow.beginPath();
                            that.ctxShadow.strokeRect(x, y, e.offsetX - x, e.offsetY - y);
                        }
                    };
                });
            },
            /**
             * 画圆形
             * @author 江涛
             * @date 2019/2/22
             */
            drawCircle() {
                this.judgeChar();
                let x = 0,
                    y = 0,
                    flag = false,
                    that = this;
                this.selectedDraw = 'Circle';
                this.missionCanvasShadow(true, function () { //是否需要阴影画布
                    that.$refs.missionFeedbackEditShadow.onmousedown = function (e) {
                        flag = true;
                        x = e.offsetX; // 鼠标落下时的X
                        y = e.offsetY; // 鼠标落下时的Y
                    };
                    that.$refs.missionFeedbackEditShadow.onmouseup = function (e) {
                        flag = false;
                        that.ctxShadow.clearRect(0, 0, that.$refs.missionFeedbackEditShadow.width, that.$refs.missionFeedbackEditShadow.height);//清空影子
                        const rx = e.offsetX - x;
                        const ry = e.offsetY - y;
                        that.ctx.beginPath();
                        that.ctx.ellipse(Math.abs(x), Math.abs(y), Math.abs(rx), Math.abs(ry), 0, 0, Math.PI * 2);
                        that.ctx.stroke();
                        that.ctx.save();//保存主体
                        that.missionImgList.push(document.getElementById('missionFeedbackEdit').toDataURL());               // 每次 mouseup 都保存一次画布状态
                    };
                    that.$refs.missionFeedbackEditShadow.onmousemove = function (e) { // 绘制方法
                        if (flag) {
                            that.ctxShadow.clearRect(-Math.abs(x) - 5000, -Math.abs(y) - 5000, Math.abs(x) + 10000, Math.abs(y) + 10000);
                            const rx = e.offsetX - x;
                            const ry = e.offsetY - y;
                            that.ctxShadow.beginPath();
                            that.ctxShadow.ellipse(Math.abs(x), Math.abs(y), Math.abs(rx), Math.abs(ry), 0, 0, Math.PI * 2);
                            that.ctxShadow.stroke();
                        }
                    };
                });
            },
            /**
             * 画线
             * @author 江涛
             * @date 2019/2/22
             */
            drawLine() {
                this.judgeChar();
                let x = 0,
                    y = 0,
                    flag = false,
                    that = this;
                this.selectedDraw = 'Line';
                this.missionCanvasShadow(false, function () { //是否需要阴影画布
                    that.$refs.missionFeedbackEdit.onmousedown = function (e) {
                        flag = true;
                        x = e.offsetX; // 鼠标落下时的X
                        y = e.offsetY; // 鼠标落下时的Y
                        that.ctx.moveTo(x, y);//设置主体上的起点
                    };
                    that.$refs.missionFeedbackEdit.onmouseup = function (e) {
                        flag = false;
                        that.missionImgList.push(document.getElementById('missionFeedbackEdit').toDataURL());               // 每次 mouseup 都保存一次画布状态
                    };
                    that.$refs.missionFeedbackEdit.onmousemove = function (e) { // 绘制方法
                        if (flag) {
                            that.ctx.lineTo(e.offsetX, e.offsetY);
                            that.ctx.stroke(); // 调用绘制方法
                        } else {
                            that.ctx.beginPath();
                            that.ctx.moveTo(x, y);
                        }
                    };
                });
            },
            /**
             * 写文字
             * @author 江涛
             * @date 2019/2/22
             */
            drawChar() {
                this.judgeChar();
                let that = this,
                    input = {};
                this.charX = 0;
                this.charY = 0;
                this.selectedDraw = 'Char';
                this.charFlag = false;
                this.missionCanvasShadow(true, function () { //是否需要阴影画布
                    that.$refs.missionFeedbackEditShadow.onmousedown = function (e) {
                        if (!that.charFlag) {
                            //新建输入框
                            that.charFlag = true;
                            that.charX = e.offsetX; // 鼠标落下时的X
                            that.charY = e.offsetY; // 鼠标落下时的Y

                            input = document.createElement('input');
                            input.onkeydown = function (e) {
                                if (e.keyCode == 13) {
                                    that.charFlag = false;
                                    that.confirmDrawChar(input.value, that.charX, that.charY);
                                    that.$refs.missionCanvas.removeChild(input);
                                }
                            };
                            input.setAttribute('id', 'missionCharInput');
                            input.setAttribute('row', '1');
                            input.addEventListener('keyup', function () {
                                that.$refs.charWidthCalculator.textContent = input.value;
                                input.style.width = that.$refs.charWidthCalculator.offsetWidth * 1.6 + 'px';
                            });
                            input.setAttribute('style', `min-width:20px;background-color:transparent;position:absolute;left:${that.charX}px;top:
                            ${that.charY}px;border:solid 2px ${that.strokeStyle};color:${that.strokeStyle};height:${that.lineWidth * 5}px;
                            line-height:${that.lineWidth * 5}px;font-size:${that.lineWidth * 5}px;outline:none;z-index:20001;`
                            );
                            that.$refs.missionCanvas.appendChild(input);
                        } else {
                            //确认输入
                            that.charFlag = false;
                            that.confirmDrawChar(input.value, that.charX, that.charY);
                            that.$refs.missionCanvas.removeChild(input);
                        }
                    };
                    that.$refs.missionFeedbackEditShadow.onmouseup = function () {
                    };
                    that.$refs.missionFeedbackEditShadow.onmousemove = function () {
                    };
                });
            },
            /**
             * 确认文字，一种是用回车键，一种是鼠标点击输入框以外
             * @author 江涛
             * @date 2019/2/22
             */
            confirmDrawChar(input, x, y) {
                this.ctx.font = 'bold ' + this.lineWidth * 5 + 'px PingFang SC';
                this.ctx.textAlign = 'left';
                this.ctx.textBaseline = 'bottom';
                this.ctx.fillStyle = this.strokeStyle;
                this.ctx.fillText(input, x, y + this.lineWidth * 5 + 4);
                this.missionImgList.push(document.getElementById('missionFeedbackEdit').toDataURL());
            },
            /**
             * 判断文字是否生效
             * @author 江涛
             * @date 2019/3/12
             */
            judgeChar() {
                if (this.charFlag) { //当未确认保存图片时，自动确认已输入文字
                    this.charFlag = false;
                    this.confirmDrawChar(document.getElementById('missionCharInput').value, this.charX, this.charY);
                    this.$refs.missionCanvas.removeChild(document.getElementById('missionCharInput'));
                } else {
                    if (document.getElementById('missionCharInput')) { //当取消时，删除输入框
                        this.charFlag = false;
                        this.$refs.missionCanvas.removeChild(document.getElementById('missionCharInput'));
                    }
                }
            },
            /**
             * 画箭头
             * @author 江涛
             * @date 2019/2/22
             */
            drawArrow() {
                this.judgeChar();
                let x = 0,
                    y = 0,
                    flag = false,
                    that = this;
                this.selectedDraw = 'Arrow';
                this.missionCanvasShadow(true, function () {
                    //是否需要阴影画布
                    that.$refs.missionFeedbackEditShadow.onmousedown = function (e) {
                        flag = true;
                        x = e.offsetX; // 鼠标落下时的X
                        y = e.offsetY; // 鼠标落下时的Y
                    };
                    that.$refs.missionFeedbackEditShadow.onmouseup = function (e) {
                        flag = false;
                        that.ctxShadow.clearRect(0, 0, that.$refs.missionFeedbackEditShadow.width, that.$refs.missionFeedbackEditShadow.height);//清空影子
                        that.drawArrowFx(that.ctx, x, y, e.offsetX, e.offsetY, 40, Math.sqrt(Math.pow(e.offsetX - x, 2) + Math.pow(e.offsetY - y, 2)) / 3, that.lineWidth, that.strokeStyle);
                        that.ctx.save();//保存主体
                        that.missionImgList.push(document.getElementById('missionFeedbackEdit').toDataURL());               // 每次 mouseup 都保存一次画布状态
                    };
                    that.$refs.missionFeedbackEditShadow.onmousemove = function (e) { // 绘制方法
                        if (flag) {
                            that.ctxShadow.clearRect(0, 0, that.$refs.missionFeedbackEditShadow.width, that.$refs.missionFeedbackEditShadow.height);
                            that.drawArrowFx(that.ctxShadow, x, y, e.offsetX, e.offsetY, 40, Math.sqrt(Math.pow(e.offsetX - x, 2) + Math.pow(e.offsetY - y, 2)) / 3, that.lineWidth, that.strokeStyle);
                        }
                    };
                });
            },
            /**
             * 绘制线式箭头
             * {画布对象，起始x, 起始y, 终点x, 终点y,偏转角，箭头边长度，直线宽度，颜色}
             * @author 江涛
             * @date 2019/3/8
             */
            drawArrowFx(ctx, fromX, fromY, toX, toY, theta, headlen, width, color) {
                theta = typeof theta !== 'undefined' ? theta : 30;
                headlen = headlen >= 50 ? 50 : headlen;
                width = typeof width !== 'undefined' ? width : 1;
                color = typeof color !== 'undefined' ? color : '#000';// 计算各角度和对应的P2,P3坐标
                let angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI,
                    angle1 = (angle + theta) * Math.PI / 180,
                    angle2 = (angle - theta) * Math.PI / 180,
                    topX = headlen * Math.cos(angle1),
                    topY = headlen * Math.sin(angle1),
                    botX = headlen * Math.cos(angle2),
                    botY = headlen * Math.sin(angle2);
                ctx.save();
                ctx.beginPath();
                let arrowX = fromX - topX,
                    arrowY = fromY - topY;
                ctx.moveTo(arrowX, arrowY);
                ctx.moveTo(fromX, fromY);
                ctx.lineTo(toX, toY);
                arrowX = toX + topX;
                arrowY = toY + topY;
                ctx.moveTo(arrowX, arrowY);
                ctx.lineTo(toX, toY);
                arrowX = toX + botX;
                arrowY = toY + botY;
                ctx.lineTo(arrowX, arrowY);
                ctx.strokeStyle = color;
                ctx.lineWidth = width;
                ctx.stroke();
                ctx.restore();
            },
            /**
             * 撤销一步
             * @author 江涛
             * @date 2019/2/22
             */
            lastStep() {
                const that = this;
                const img = new Image();
                this.missionImgList.splice(-1, 1);
                img.src = this.missionImgList[this.missionImgList.length - 1];
                if (this.missionImgList.length === 0) {
                    this.ctx.drawImage(this.$refs.missionFeedbackImg, 0, 0, 1200, 650);
                    return;
                }
                img.onload = function () { //监听img对象加载完成
                    that.ctx.drawImage(img, 0, 0, 1200, 650);
                };
            },
            /**
             * 阴影画布的调整
             * @author 江涛
             * @date 2019/2/22
             */
            missionCanvasShadow(x, fx) {
                this.missionShadow = x;
                this.$nextTick(function () {
                    // 此时已经渲染完成
                    if (x) {
                        this.ctxShadow = this.$refs.missionFeedbackEditShadow.getContext('2d');
                        this.ctxShadow.strokeStyle = this.strokeStyle;
                        this.ctxShadow.lineWidth = this.lineWidth;
                    }
                    fx();
                });
            },
            /**
             * desc
             * @author zhanglijuan
             * @date 2019-03-12
             * @params
             */
            async confirmMesage() {
                try {
                    const params = {
                        filtersRaw: JSON.stringify([
                            {id: 'userId', property: 'userId', value: appCtx.userId},
                            {id: 'isRead', property: 'isRead', value: 'N'}
                        ]),
                        onlyCountFlag: true
                    };
                    const data = await this.$http.post(`/${LinkVue.prefixUrl}/pushNotice/queryByExamplePage`, params);
                    if (data.success) {
                        this.notReadNum = data.rows[0].total;
                    } else {
                        this.$nav.error('阅读消息发生了错误:' + data.result);
                    }
                } catch (e) {
                    this.$nav.error('阅读消息发生了错误:' + e);
                }
            }
        },
        async mounted() {
            await this.getCfgProperty(); // 获取企业参数
        },
        beforeDestroy() {
            /*页面销毁之前，移除监听的粘贴事件*/
            this.$refs.pastePicBox.removeEventListener('paste', this.onPaste)
        },
    };
</script>

<style lang="scss">

    .mission-feedback-dialog {
        .mission-canvas-button-group {
            float: right;
            color: white;
            width: 640px;
            height: 33px;
            background-color: #000;
            opacity: 0.7;
            border-radius: 5px;
            padding: 7px 10px 0 10px;
            display: flex;
            justify-content: space-between;
        }

        .mission-canvas-button-group span {
            padding: 0 9px;
            cursor: pointer;
        }

        .iconfont {
            font-size: 24px;
        }

        .mission-canvas-modal {
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            opacity: .5;
            background: #000;
            z-index: 1000;
        }

        .icon-shixinzhengfangxing-red {
            color: #CC0000;
        }

        .icon-shixinzhengfangxing-blue {
            color: #3333FF;
        }

        .icon-shixinzhengfangxing-black {
            color: #333333;
        }

        .icon-line-width-active:before {
            border: solid 1px #ffffff
        }

        .icon-stroke-style-active:before {
            border: solid 1px #ffffff
        }

        .el-dialog {
            width: 720px;
        }

        .el-form-item__content {
            width: calc(100% - 110px);
        }

        .el-upload--picture-card {
            border-radius: 0;
        }

        .el-textarea__inner {
            border-radius: 0;
        }

        #paste-pic-box {
            width: 148px;
            height: 148px;
            display: inline-block;
            border: 1px solid #c0ccda;
            float: left;
        }

        .paste-form-item {
            display: block;
            margin-left: 100px;

            .el-form-item__content {
                width: calc(100%) !important;
            }
        }

        .paste-img-line {
            width: 100%;

            .paste-img-column {
                position: relative;
                display: inline-block;
                width: 150px;
                height: 150px;
                margin-right: 10px;
                margin-bottom: 10px;
                float: left;

                &:hover {
                    .delete-mask {
                        opacity: 1;
                    }
                }

                .paste-pic-img {
                    width: 148px;
                    height: 148px;
                    display: inline-block;
                    border: 1px solid #c0ccda;
                    border-radius: 4px;
                }

                .delete-mask {
                    opacity: 0;
                    position: absolute;
                    width: 150px;
                    height: 48px;
                    left: 0px;
                    top: 101px;
                    cursor: default;
                    text-align: center;
                    color: #c0ccda;
                    font-size: 20px;
                    background-color: rgba(0, 0, 0, .4);
                    -webkit-transition: opacity .3s;
                    transition: opacity .3s;
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
</style>
